<template>
  <div>
    <form @submit.prevent="submit">
      <div class="form-group">
        <FloatingLabel
          v-if="!isForeign"
          type="tel"
          input-class="form-control form-control-xl bg-light-2 border-0"
          label="CPF"
          v-model="document"
          v-mask="'###.###.###-##'"
        />
        <FloatingLabel
          v-if="isForeign"
          type="tel"
          input-class="form-control form-control-xl bg-light-2 border-0"
          label="RNE"
          v-model="document"
          v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXX'"
        />
      </div>

      <div class="text-center">
        <a
          href="#"
          class="text-wl-secondary font-weight-bold mr-3"
          @click.prevent="$emit('changeModal', 'login')"
          >Voltar para Login</a
        >
        <button
          type="submit"
          class="btn btn-wl-secondary px-4"
          :disabled="!disabledForm"
        >
          Cadastrar meu currículo
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import FloatingLabel from "@/components/FloatingLabel";

export default {
  name: "PreRegister",

  data() {
    return {
      isForeign: false,
      document: "",
    };
  },

  computed: {
    disabledForm() {
      return (
        (this.isForeign && this.document.length > 5) ||
        (!this.isForeign && this.$helpers.isCPF(this.document))
      );
    },
  },

  components: {
    FloatingLabel,
  },

  methods: {
    submit() {
      this.$store.commit("DEVISE_LOADING", true);

      this.$store
        .dispatch(
          "graphql_queries/query",
          `
          users( ${this.isForeign ? "passport:" : "cpf:"} "${this.document}" ){
            email,
            name,
            avatar
          }
        `
        )
        .then((results) => {
          if (results.users && results.users.length >= 1) {
            this.$store.commit("DEVISE_TRYING", results.users[0]);
            this.$emit("changeModal", "userExists");
          } else {
            this.$store.commit("DEVISE_TRYING", {
              isForeign: this.isForeign,
              document: this.document,
            });
            this.$emit("changeModal", "register");
          }

          this.$store.commit("DEVISE_LOADING", false);
        });
    },
  },
};
</script>

<style lang="scss"></style>